import React, { useEffect, useState } from 'react'
import { Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import { useAuth } from '../pages/AuthContext';
import { ScaleLoader } from 'react-spinners';
import { useNavigate } from "react-router-dom"

const UNIDADES_ACADEMICAS = [
    'Ciencias Sociales',
    'Ciencia y Tecnología',
    'C.E.I.',
    'UVQ',
    'Economía y Administración',
    'Escuela Universitaria de Artes'
]

const ESTADOS_DOCENTE = [
    'Nuevo',
    'Ingreso',
    'Carga cerrada',
    'No evaluado',
    'Evaluación cerrada',
    'Confirmó resolución',
    'Re ingreso'
]

export default function ListadoDocentesAEvaluar({ usuario }) {

    const { darkMode } = useDarkMode();
    const { token } = useAuth();
    const navigate = useNavigate()

    const dynamicStyles = darkMode ? darkModeStyles : lightModeStyles;

    const [docentes, setDocentes] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalCount, setTotalCount] = useState(0)
    const [hasNext, setHasNext] = useState(false)
    const [hasPrevious, setHasPrevious] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [searchQuery, setSearchQuery] = useState('')
    const [unidadAcademicaFiltro, setUnidadAcademicaFiltro] = useState('')
    const [estadoFiltro, setEstadoFiltro] = useState('')

    const fetchDocentes = async (page = 1, query = '', unidadAcademica = '', estado = '') => {
        setLoading(true)
        setError(null)
        try {
            const url = new URL(`${process.env.REACT_APP_API_URL}/docentes/`)
            url.searchParams.set('page', page)
            if (query) {
                url.searchParams.set('q', query)
            }
            if (unidadAcademica) {
                url.searchParams.set('unidad', unidadAcademica)
            }
            if (estado) {
                url.searchParams.set('estado', estado)
            }

            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })

            if (!response.ok) {
                throw new Error('Error al cargar docentes')
            }
            const data = await response.json()
            setDocentes(data.results || [])
            setTotalCount(data.count || 0)
            setHasNext(!!data.next)
            setHasPrevious(!!data.previous)
            setCurrentPage(page)
        } catch (err) {
            setError(err.message || 'Error al cargar docentes')
            setDocentes([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (token) {
            fetchDocentes(1, '')
        }
    }, [token])

    const handleBuscar = () => {
        setCurrentPage(1)
        setSearchQuery(searchInput)
        fetchDocentes(1, searchInput, unidadAcademicaFiltro, estadoFiltro)
    }

    const handleLimpiarBusqueda = () => {
        setSearchInput('')
        setSearchQuery('')
        setCurrentPage(1)
        fetchDocentes(1, '', unidadAcademicaFiltro, estadoFiltro)
    }

    const aplicarFiltros = (pagina = 1, query = searchQuery, unidadAcademica = unidadAcademicaFiltro, estado = estadoFiltro) => {
        setCurrentPage(pagina)
        fetchDocentes(pagina, query, unidadAcademica, estado)
    }

    const handleCambioUnidadAcademica = (e) => {
        const nuevoValor = e.target.value
        setUnidadAcademicaFiltro(nuevoValor)
        aplicarFiltros(1, searchQuery, nuevoValor, estadoFiltro)
    }

    const handleCambioEstado = (e) => {
        const nuevoValor = e.target.value
        setEstadoFiltro(nuevoValor)
        aplicarFiltros(1, searchQuery, unidadAcademicaFiltro, nuevoValor)
    }

    const handleEnterKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleBuscar()
        }
    }

    const handleSiguiente = () => {
        if (hasNext) {
            fetchDocentes(currentPage + 1, searchQuery, unidadAcademicaFiltro, estadoFiltro)
        }
    }

    const handleAnterior = () => {
        if (hasPrevious) {
            fetchDocentes(currentPage - 1, searchQuery, unidadAcademicaFiltro, estadoFiltro)
        }
    }

    const irADetalleDocente = (docenteId) => {
        // Período hardcodeado, preguntar si quieren seleccionar uno o si siempre es el actual
        const evaluacion = {
            "id": 1,
            "deleted": null,
            "deleted_by_cascade": false,
            "fecha_inicio": "2019-04-01",
            "fecha_fin": "2023-03-31",
            "descripcion": "Período de evaluación 2019-2023"
        }
        const rolNavegacion = usuario?.rol === 'Operador' ? 'Operador' : 'Admin'
        const docenteSeleccionado = {
            "id": docenteId,
            "rol": rolNavegacion
        }
        const rutaDestino = rolNavegacion === 'Operador' ? '/resumen' : '/formulario'
        navigate(rutaDestino, {
            replace: true,
            state: {
                usuario: docenteSeleccionado,
                evaluacion,
                bloquearEdicion: rolNavegacion === 'Operador'
            }
        });
    }
    return (
        <div className="mb-5">
            {loading ?
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '200px'
                }}>
                    <ScaleLoader color='#972034' />
                </div>
                :
                <>
                    <h2 className="pb-2" style={dynamicStyles.title}>Seleccione un docente a evaluar</h2>

                    {/* Búsqueda */}
                    <div style={styles.searchContainer}>
                        <input
                            type="text"
                            placeholder="Buscar por nombre, apellido o ID exacto..."
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            onKeyPress={handleEnterKeyPress}
                            style={styles.searchInput}
                        />
                        <button
                            onClick={handleBuscar}
                            style={styles.searchButton}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#7d1820'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#972034'}
                        >
                            🔍 Buscar
                        </button>
                        {(searchQuery || unidadAcademicaFiltro || estadoFiltro) && (
                            <button
                                onClick={() => {
                                    setSearchInput('')
                                    setSearchQuery('')
                                    setUnidadAcademicaFiltro('')
                                    setEstadoFiltro('')
                                    setCurrentPage(1)
                                    fetchDocentes(1, '', '', '')
                                }}
                                style={styles.clearButton}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#999'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#aaa'}
                            >
                                ✕ Limpiar
                            </button>
                        )}
                    </div>

                    <div style={styles.searchContainer}>
                        <div style={styles.filterControlWrap}>
                            <label style={styles.filterLabel}>Unidad Académica</label>
                            <select
                                value={unidadAcademicaFiltro}
                                onChange={handleCambioUnidadAcademica}
                                style={styles.selectFilter}
                            >
                                <option value="">Todos</option>
                                {UNIDADES_ACADEMICAS.map((unidad) => (
                                    <option key={unidad} value={unidad}>
                                        {unidad}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div style={styles.filterControlWrap}>
                            <label style={styles.filterLabel}>Estado</label>
                            <select
                                value={estadoFiltro}
                                onChange={handleCambioEstado}
                                style={styles.selectFilter}
                            >
                                <option value="">Todos</option>
                                {ESTADOS_DOCENTE.map((estado) => (
                                    <option key={estado} value={estado}>
                                        {estado}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {(unidadAcademicaFiltro || estadoFiltro) && (
                        <div style={styles.activeFiltersRow}>
                            {unidadAcademicaFiltro && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        setUnidadAcademicaFiltro('')
                                        aplicarFiltros(1, searchQuery, '', estadoFiltro)
                                    }}
                                    style={styles.activeFilterChip}
                                >
                                    <span style={styles.activeFilterLabel}>Unidad Académica:</span>
                                    <span style={styles.activeFilterValue}>{unidadAcademicaFiltro}</span>
                                    <span style={styles.activeFilterClose}>×</span>
                                </button>
                            )}
                            {estadoFiltro && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        setEstadoFiltro('')
                                        aplicarFiltros(1, searchQuery, unidadAcademicaFiltro, '')
                                    }}
                                    style={styles.activeFilterChip}
                                >
                                    <span style={styles.activeFilterLabel}>Estado:</span>
                                    <span style={styles.activeFilterValue}>{estadoFiltro}</span>
                                    <span style={styles.activeFilterClose}>×</span>
                                </button>
                            )}
                        </div>
                    )}

                    {error && (
                        <div style={styles.errorMessage}>
                            {error}
                        </div>
                    )}

                    {docentes.length === 0 && !loading && !error && (
                        <div style={styles.emptyMessage}>
                            No se encontraron docentes{searchQuery ? ' para la búsqueda' : ''}
                        </div>
                    )}

                    {docentes.length > 0 &&
                        <>
                            <div style={styles.paginationSummary}>
                                Mostrando {(currentPage - 1) * 20 + 1} - {Math.min(currentPage * 20, totalCount)} de {totalCount} docentes
                            </div>

                            <div className="list-group">
                                {docentes.map((docente) => {
                                    const mailPrincipal = (docente.mail || '').trim()
                                    const documentoTexto = `${docente.tipo_documento || 'Documento'} ${docente.documento || '-'}`
                                    const numeroCelular = String(docente.numero_celular || '').trim()
                                    const unidadAcademica = String(docente.unidad_academica || '').trim()
                                    const estadoActual = String(docente.estado_actual_label || '').trim()

                                    return (
                                        <div
                                            key={docente.id}
                                            className="list-group-item list-group-item-action shadow-sm rounded mb-2"
                                            style={{
                                                position: 'relative',
                                                overflow: 'visible',
                                                cursor: "pointer",
                                                backgroundColor: darkMode ? '#2c2c2c' : '#f9f9f9',
                                                color: darkMode ? '#fff' : '#000',
                                            }}
                                            onClick={() => irADetalleDocente(docente.id)}
                                        >
                                            <div
                                                style={{
                                                    ...styles.idFlag,
                                                    backgroundColor: darkMode ? '#7d1820' : '#972034'
                                                }}
                                            >
                                                #{docente.id}
                                            </div>

                                            <div style={styles.cardContentWithFlag}>
                                                <h5 className="mb-1" style={{ margin: 0 }}>
                                                    {docente.nombre} {docente.apellido}
                                                </h5>
                                                <div style={{ marginTop: 2, fontSize: 13, color: darkMode ? '#c9c9c9' : '#555' }}>
                                                    Legajo: {docente.legajo}
                                                </div>
                                                <div style={{ marginTop: 2, fontSize: 13, color: darkMode ? '#c9c9c9' : '#555' }}>
                                                    {documentoTexto}
                                                </div>
                                                <div style={{ marginTop: 2, fontSize: 13, color: darkMode ? '#c9c9c9' : '#555' }}>
                                                    Mail: {mailPrincipal || '-'}
                                                </div>
                                                <div style={{ marginTop: 2, fontSize: 13, color: darkMode ? '#c9c9c9' : '#555' }}>
                                                    Celular: {numeroCelular || '-'}
                                                </div>
                                                <div style={{ marginTop: 2, fontSize: 13, color: darkMode ? '#c9c9c9' : '#555' }}>
                                                    Unidad Académica: {unidadAcademica || '-'}
                                                </div>
                                                <div style={{ marginTop: 2, fontSize: 13, color: darkMode ? '#c9c9c9' : '#555' }}>
                                                    Estado actual: {estadoActual || '-'}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Controles de paginación */}
                            <div style={styles.paginationContainer}>
                                <button
                                    onClick={handleAnterior}
                                    disabled={!hasPrevious || loading}
                                    style={{
                                        ...styles.paginationButton,
                                        opacity: (!hasPrevious || loading) ? 0.5 : 1,
                                        cursor: (!hasPrevious || loading) ? 'not-allowed' : 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (hasPrevious && !loading) {
                                            e.target.style.backgroundColor = '#7d1820'
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#972034'
                                    }}
                                >
                                    ← Anterior
                                </button>
                                <span style={styles.pageIndicator}>Página {currentPage}</span>
                                <button
                                    onClick={handleSiguiente}
                                    disabled={!hasNext || loading}
                                    style={{
                                        ...styles.paginationButton,
                                        opacity: (!hasNext || loading) ? 0.5 : 1,
                                        cursor: (!hasNext || loading) ? 'not-allowed' : 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (hasNext && !loading) {
                                            e.target.style.backgroundColor = '#7d1820'
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#972034'
                                    }}
                                >
                                    Siguiente →
                                </button>
                            </div>
                        </>
                    }
                </>
            }
        </div>
    )
}

const lightModeStyles = {
    title: {
        color: '#A23C41',
        borderBottom: '4px solid #646354'
    }
};

const darkModeStyles = {
    title: {
        borderBottom: '4px solid #495057'
    }
};
const styles = {
    ...{
        searchContainer: {
            display: 'flex',
            gap: '10px',
            marginBottom: '12px',
            alignItems: 'center',
            flexWrap: 'wrap'
        },
        filterControlWrap: {
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            minWidth: '210px'
        },
        filterLabel: {
            fontSize: '12px',
            fontWeight: '700',
            color: '#6b7280',
            letterSpacing: '0.02em',
            textTransform: 'uppercase'
        },
        searchInput: {
            flex: 1,
            minWidth: '250px',
            padding: '12px 14px',
            border: '1px solid rgba(151, 32, 52, 0.22)',
            borderRadius: '14px',
            fontSize: '14px',
            fontFamily: 'inherit'
        },
        selectFilter: {
            minWidth: '210px',
            padding: '12px 14px',
            border: '1px solid rgba(151, 32, 52, 0.22)',
            borderRadius: '14px',
            fontSize: '14px',
            fontFamily: 'inherit',
            backgroundColor: '#fff',
            color: '#111827',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
            outline: 'none'
        },
        searchButton: {
            padding: '10px 16px',
            backgroundColor: '#972034',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        clearButton: {
            padding: '10px 16px',
            backgroundColor: '#aaa',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        activeFiltersRow: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            marginBottom: '18px'
        },
        activeFilterChip: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            border: '1px solid rgba(151, 32, 52, 0.16)',
            backgroundColor: '#fff7f8',
            color: '#7d1820',
            borderRadius: '999px',
            padding: '8px 12px',
            fontSize: '13px',
            fontWeight: '700',
            cursor: 'pointer',
            boxShadow: '0 6px 16px rgba(151, 32, 52, 0.08)',
            transition: 'transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease'
        },
        activeFilterLabel: {
            opacity: 0.72,
            fontWeight: '700'
        },
        activeFilterValue: {
            fontWeight: '800'
        },
        activeFilterClose: {
            width: '18px',
            height: '18px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            backgroundColor: 'rgba(151, 32, 52, 0.12)',
            fontSize: '16px',
            lineHeight: 1,
            color: '#972034'
        },
        errorMessage: {
            padding: '12px 16px',
            backgroundColor: '#f8d7da',
            color: '#721c24',
            borderRadius: '6px',
            marginBottom: '16px',
            fontSize: '14px'
        },
        emptyMessage: {
            padding: '20px',
            textAlign: 'center',
            color: '#666',
            fontSize: '16px',
            marginTop: '20px'
        },
        paginationSummary: {
            fontSize: '13px',
            color: '#666',
            marginBottom: '12px',
            fontWeight: '500'
        },
        paginationContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '16px',
            marginTop: '20px'
        },
        paginationButton: {
            padding: '10px 16px',
            backgroundColor: '#972034',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.2s'
        },
        pageIndicator: {
            fontSize: '14px',
            fontWeight: '600',
            minWidth: '80px',
            textAlign: 'center'
        },
        cardContentWithFlag: {
            paddingLeft: '34px'
        },
        idFlag: {
            position: 'absolute',
            left: '-14px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#fff',
            fontWeight: '700',
            fontSize: '12px',
            letterSpacing: '0.2px',
            padding: '6px 10px',
            borderRadius: '0 8px 8px 0',
            boxShadow: '0 6px 14px rgba(0, 0, 0, 0.22)',
            zIndex: 2
        }
    }
};